export default __webpack_public_path__ + "static/media/CarImages.KigerLarge.c919ee6e.jpg";